import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";
import SidebarMenu from "react-bootstrap-sidebar-menu";
import { baseURL } from "../../config";

function CreateClusterAndCompCombo() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [cluster, setCluster] = useState(null);
  const [options, setOptions] = useState([]);
  const [comp, setComp] = useState([]);
  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getallclusters`
        );
        setOptions(response.data.clusteres);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions();
  }, []);

  useEffect(() => {
    const fetchComp = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getcompetencies`
        );
        setComp(response.data.competencies);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchComp();
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = async () => {
    try {
      const response = await fetch(`${baseURL}/addgrade`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFormData(null);
        setShowModal(false);

        window.location.href = "/createTemplateTab";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          clustername: "",
        }}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <div className="container">
            <h4 className="text-start  pb-2">CREATE CLUSTER</h4>
            <div className="col-lg-12  mt-1 m-5">
              <form noValidate onSubmit={handleSubmit}>
                <div className="row">
                  <div class="col-lg-5 ml-2">
                    <label>Name of Cluster</label>
                    <select
                      className="form-select form-control"
                      name="clusters"
                    >
                      {options.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.clustername}
                        </option>
                      ))}
                    </select>
                    <div>
                      <div>
                        <a
                          className="btn btn-primary bviolet mt-3 p-2 text-decoration-none mt-4"
                          href="/AddClusterbut"
                        >
                          Add Cluster +
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-5 ml-2">
                    <label>Competency Name</label>
                    <select
                      multiple={true}
                      className="form-select form-control"
                      name="competencies"
                      value={values.competencies}
                      onChange={handleChange}
                    >
                      {comp.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.competency}
                        </option>
                      ))}
                    </select>
                    <div>
                      <div>
                        <a
                          className="btn btn-primary bviolet mt-3 p-2 text-decoration-none mt-4"
                          href="/AddCompetencybut"
                        >
                          Add Competency +
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-11 text-end mt-4 pb-3">
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <a href="/comboclusandcomp" className="text-decoration-none ">
                    {" "}
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>

      {/* Confirmation Modal */}
      <div className="col-lg-12">
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Do You Want to Create the cluster?</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleConfirmSubmit}>
              Yes
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default CreateClusterAndCompCombo;
